import React from 'react'
import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from '~/lib/ui/table'
import Pagination from './Pagination'
import { useCandidate } from './CandidateProvider'
import { useFormatTime } from '~/hooks/useFormatTime'

const PAGE_SIZE = 50

const CoachHistory = () => {
  const { coachHistories } = useCandidate()
  const [page, setPage] = React.useState(1)
  const total = coachHistories?.length || 0

  // Paginate activities
  const paginated = React.useMemo(() => {
    if (!coachHistories) return []
    const start = (page - 1) * PAGE_SIZE
    return coachHistories.slice(start, start + PAGE_SIZE)
  }, [coachHistories, page])

  return (
    <>
      <Table
        className="w-full border-separate"
        tableClass="w-full rounded-2xl border border-silver"
      >
        <CoachHistoryHeading />
        <TableBody>
          {total === 0 ? (
            <TableRow>
              <TableCell colSpan={4} className="py-8 text-center text-gray-500">
                No coach history available.
              </TableCell>
            </TableRow>
          ) : (
            paginated.map((coachHistory, idx) => (
              <CoachHistoryRow
                key={`coach-history-${coachHistory.id ?? idx}`}
                coachHistory={coachHistory}
              />
            ))
          )}
        </TableBody>
      </Table>
      {total > PAGE_SIZE && (
        <Pagination
          page={page}
          pageSize={PAGE_SIZE}
          total={total}
          onPageChange={setPage}
        />
      )}
    </>
  )
}

export default CoachHistory

const CoachHistoryRow = ({ coachHistory, ...props }) => {
  const { assigned_coach, assigned_by, assigned_at, event_type } =
    coachHistory || {}
  const formatTime = useFormatTime()
  return (
    <TableRow
      {...props}
      className="odd:bg-white even:bg-[#e2e2e2] even:bg-opacity-[29%]"
    >
      <TableCell>{assigned_coach}</TableCell>
      <TableCell>{assigned_by}</TableCell>
      <TableCell>{formatTime(assigned_at)}</TableCell>
      <TableCell>{event_type}</TableCell>
    </TableRow>
  )
}

const CoachHistoryHeading = () => {
  const cells = ['Assigned Coach', 'Assigned By', 'Assigned At', 'Event Type']
  return (
    <TableHeader className="h-6 bg-intoo-blue-medium">
      <TableRow className="text-lg text-white hover:bg-intoo-blue-medium">
        {cells.map((cell, index) => (
          <TableHead key={index} className="font-medium text-white">
            {cell}
          </TableHead>
        ))}
      </TableRow>
    </TableHeader>
  )
}
